import { Prospect } from '~/generated/graphql';

import { ListItem } from './ListItem';
import { LoadingList } from './LoadingList';

type ListProps = {
  isLoading?: boolean;
  onSelectItem: (id: string) => void;
  onDeselectItem: (id: string) => void;
  prospects: Prospect[];
  selectedProspects: string[];
};

export const List = ({
  isLoading,
  onSelectItem,
  onDeselectItem,
  prospects,
  selectedProspects,
}: ListProps) => {
  return (
    <div className="space-y-4">
      {isLoading ? (
        <LoadingList />
      ) : (
        prospects.map((prospect) => {
          const isSelected = selectedProspects.includes(prospect.id);

          const handleSelect = () => {
            if (isSelected) {
              onDeselectItem(prospect.id);
            } else {
              onSelectItem(prospect.id);
            }
          };
          return (
            <ListItem
              isSelected={isSelected}
              key={prospect.id}
              onSelect={handleSelect}
              prospect={prospect}
            />
          );
        })
      )}
    </div>
  );
};
